const PREFIX = 'CLUB_LOCATOR_';

export const GET_FACILITIES_FOR_MAP = `${PREFIX}GET_FACILITIES_FOR_MAP`;
export const SET_FACILITIES_FOR_MAP = `${PREFIX}SET_FACILITIES_FOR_MAP`;
export const SET_LIST_VIEW_FOR_MAP = `${PREFIX}SET_LIST_VIEW_FOR_MAP`;
export const GET_PLANS_FOR_MAP = `${PREFIX}GET_PLANS_FOR_MAP`;
export const SET_PLANS_FOR_MAP = `${PREFIX}SET_PLANS_FOR_MAP`;
